import React, { useState, useEffect } from "react";
import { useLocation, useParams, useNavigate, Link } from "react-router-dom";
// import Card from "react-bootstrap/Card";
import { Table, Badge, OverlayTrigger, Tooltip, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import Select from "react-select";
import API from "../../../services/axiosInstance";
import "./InstreamSetting.css"
import { FormLoader, useFormLoader } from "../../common_modules/loader";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";

// import useSubmitPrevent from "../../utils/SubmitPrevent";
import usePreventMultiClick from "../../utils/SubmitPrevent";

// const contentManagement = [
//     {value : "1", label:"AdTest-1"},
//     {value : "2", label:"AdTest-2"},
//     {value : "3", label:"AdTest-3"},
//     {value : "4", label:"AdTest-4"},
//     {value : "5", label:"AdTest-5"},
//     {value : "6", label:"AdTest-6"}
// ];

const mobilePlayerSizes = [
    { value: "300*250", label: "300*250" },
    { value: "336*280", label: "336*280" },
    { value: "500*280", label: "500*280" },
    { value: "640*360", label: "640*360" },
    { value: "1280*720", label: "1280*720" },
    { value: "1200*627", label: "1200*627" },
    { value: "custom", label: "custom" },
]

const desktopPlayerSizes = [
    { value: "300*250", label: "300*250" },
    { value: "336*280", label: "336*280" },
    { value: "500*280", label: "500*280" },
    { value: "640*360", label: "640*360" },
    { value: "1280*720", label: "1280*720" },
    { value: "1200*627", label: "1200*627" },
    { value: "custom", label: "custom" },
]

// const selectAdOptions = [
//     {value:"", label:"Select Ad"},
//     {value:"0", label:"AdSetup1"},
//     {value:"2", label:"AdSetup2"},
//     {value:"3", label:"AdSetup3"},
//     {value:"4", label:"AdSetup4"},
//     {value:"5", label:"AdSetup5"},
//     {value:"6", label:"AdSetup6"},
// ]
const InstreamAdSetting = ({
    mode = 'add',
    publisherId,
    publisherGuid,
    defaultValues = {},
    instreamMeta,
}) => {
    const [publisherName, setPublisherName] = useState("");

    const navigate = useNavigate();
    const location = useLocation();
    const pubId = location?.state?.publisherId;

    // const pubGuid = location?.state?.publisherGuid;

    const url = useParams();
    const accId = url?.id;
    const accGuid = url?.guid;


    const [contentOptions, setContentOptions] = useState([]);
    const [adList, setAdList] = useState([]);
    const [rawAdList, setRawAdList] = useState([]);

    // custom hook loader
    const { isLoading, startLoading, stopLoading } = useFormLoader();
    // submit dublicate click prevant 
    // const submittingRef = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

    const { control, handleSubmit, register, watch, reset, formState: { errors }, } = useForm({
        shouldUnregister: true,
        defaultValues: {
            detach_close_action: "1",
            contentMnglist: null,
            mobileSize: null,
            customWidth: "",
            customHeight: "",
            desktopSize: null,
            inview: 4,
            // selectAd:null,
            // out_of_view: 2,
            ads: [
                {
                    selectAd: null,
                    adType: "PRE",
                    adTime: ""
                }
            ]
        },
    });
    const { fields, append, remove, replace } = useFieldArray({
        control,
        name: "ads",
    });

    // content management api 
    const contentApi = async () => {
        const contentResp = await API.get('/meta/content/list/limited');
        const options = contentResp?.data?.data?.map((item) => ({
            value: item.id,
            label: item.name,
        }));
        setContentOptions(options);
    }
    // content management api 
    const AdData = async () => {
        const AdDataRes = await API.get(`/publisher/instream/ad/setup/adsetting/list/${accId}`);
        const adData = AdDataRes?.data?.data || [];
        setPublisherName(AdDataRes?.data?.name);

        setRawAdList(adData);
        const options = adData.map((item) => ({
            value: item.id,
            label: item.title,
            status: item.status,
        }));
        setAdList(options);
    }
    // Watch the selected mobile size
    const selectedMobileSize = watch("mobileSize");
    const selectedDesktopSizes = watch("desktopSize");
    const initialAdRequest = watch("init_ad_req");
    const seekbarEnable = watch("video_controls");
    const selectedAdTime = watch("adType");
    const IsDetachableYes = watch("is_detachable");
    const RetryAdYes = watch("is_retry");
    const IsContentReplay = watch("is_content_replay");
    const IsCompanionAdYes = watch("is_companion_ad");

    const buildPayload = (data) => {
        const payload = {
            id: mode === "edit" ? instreamMeta?.id : 0,
            guid: mode === "edit" ? instreamMeta?.guid : "",
            accId: mode === "edit" ? defaultValues.accId : accId,
            accGuid: mode === "edit" ? defaultValues.accGuid : accGuid,
            status: 1,

            instreamLabel: (data?.label).trim(),
            contentId: data?.contentManag?.value,

            mobilePlayerSizes: data?.mobileSize?.value,
            customMobilePlayerSizes: data?.custom_mob_width && data?.custom_mob_height ? `${data?.custom_mob_width}*${data?.custom_mob_height}` : '',
            desktopPlayerSizes: data?.desktopSize?.value,
            customDesktopPlayerSizes: data?.custom_desk_width && data?.custom_Desk_Height ? `${data?.custom_desk_width}*${data?.custom_Desk_Height}` : '',

            headerBiding: data?.header_biding,
            initialAdrequest: data?.init_ad_req,
            autoplay: data?.autoPlay,
            // viewportInitialRequest:data?.view_port_init_req,
            outOfView: data?.out_of_view,
            inView: data?.in_view,

            videoControls: data?.video_controls,
            videoControlsEnable: data?.video_controls_enable,
            adControls: data?.ad_controls,

            poweredByLink: (data?.powered_by_link).trim(),
            poweredByText: (data?.powered_by_text).trim(),
            poweredByImg: (data?.powered_by_img).trim(),

            isDetachable: data?.is_detachable,
            bottomPx: data?.bottom_px,
            detachViewport: data?.viewport_init_req_detach,
            detachCloseAction: data?.detach_close_action,

            detachMobileSize: data?.detach_mobile_width && data?.detach_mobile_height ? `${data?.detach_mobile_width}*${data?.detach_mobile_height}` : '',
            detachDesktopSize: data?.detach_desktop_width && data?.detach_desktop_height ? `${data?.detach_desktop_width}*${data?.detach_desktop_height}` : '',

            wrapperStyle: (data?.wrapper_style).trim(),

            isRetry: data?.is_retry,
            retryInterval: data?.retry_interval,
            maxRetryCount: data?.max_retry_count,
            maxAdDisplayCount: data?.max_ad_display_count,

            isContentReplay: data?.is_content_replay,
            contentReplayCount: data?.content_replay_count,

            isCompanionAd: data?.is_companion_ad,
            companionAdUnit: data?.is_companion_ad_unit,

            documentViewability: '',
            remarks: '',
            viaGam: data?.via_Gam,
            // macros:,
            // adJsonData:,
            // settingOptions:data?.ads?.map((ad) => ({
            //     instreamSetupId: 0,
            //     adId: Number(ad?.selectAd.value),
            //     adTime: ad?.adTime || "",
            //     adType: ad?.adType,
            //     id:0,
            // }))
            settingOptions: data.ads.map(ad => ({
                id: mode === "edit" ? ad.backendId : 0,
                instreamSetupId:
                    mode === "edit" ? instreamMeta.id ?? 0 : 0,
                adId: Number(ad.selectAd?.value),
                adType: ad.adType,
                adTime: ad.adTime || "",
            })),
        };
        if (data.init_ad_req === "1") {
            payload.viewportInitialRequest = data.view_port_init_req;
        }
        return payload;
    };
    const onSubmit = async (data) => {
        if(btnClicked) return;
        setBtnClicked(true);
        // if(submittingRef.current) return;
        startLoading();
        // // check status
        // const pendingAds = rawAdList.map((item, index) =>({
        //     index: index + 1,
        //     title: item.title,
        //     status: item.status,
        // })).filter((item)=>item.status === 5);
        // // Single alert for all pending ads
        // if(pendingAds?.length > 0) {
        //     const pendingMessage = pendingAds.map((ad) => `#AD Setting ${ad.index}: ${ad.title} is already pending`).join("\n");
        //     alert(pendingMessage);
        //     return;
        // }
        if(data.is_retry !== "1") {
            const restrictedAdTypes = data.ads.map( ad => ad.adType ).filter( type => ["PRE", "MID", "POST"].includes(type));
            const hasDuplicate = restrictedAdTypes.length !== new Set(restrictedAdTypes).size;
            if (hasDuplicate) {
                alert("You cannot select Multiple Ads with same AdType when Retry Ad is No!!!");
                stopLoading();
                setBtnClicked(false);
                return;
            }
        }
        const pendingAds = data.ads.map((selectedAd, index) => {
            const adInfo = rawAdList.find(item => item.id === Number(selectedAd?.selectAd?.value));
            if (adInfo?.status === 5) {
                return {
                    index: index + 1,
                    title: adInfo.title,
                };
            }
            return null;
        }).filter(Boolean);
        if (pendingAds?.length > 0) {
            const pendingMessage = pendingAds.map((ad) => `#AD Setting ${ad.index}: ${ad.title} is already pending`).join("\n");
            alert(pendingMessage);
            stopLoading();
            setBtnClicked(false);
            return;
        }
        // submittingRef.current = true;
        const payload = buildPayload(data);
        // if(mode === "add") {
        // }   
        // if(mode === "edit") {
        //     payload.id = publisherId;
        //     payload.guid = publisherGuid;
        // }  
        try {
            const apiCall =
                mode === "add"
                    ? API.post('/publisher/instream/setting/save', payload)
                    : API.put('/publisher/instream/setting/update', payload)
            const response = await apiCall;
            alert(response?.data?.message || "Success");

            if (response?.data?.status === "Success") {
                navigate(`/publisher/instream-setting-list/${accId}/${accGuid}`);
            }
        } catch (error) {
            alert(error?.response?.data?.message || "Something went wrong!");
        } finally {
            // submittingRef.current = false;
            setBtnClicked(false);
            stopLoading();
        }
    }
    // const getContentDefault = (contentId, options) => {
    //     return options.find(opt => opt.value === String(contentId)) || null;
    // };
    const getMatchedContent = (id) =>
        contentOptions.find(opt => opt.value === String(id)) || null;

    const getMatchedAd = (adId) =>
        adList.find(opt => opt.value === adId) || null;
    // useEffect(() => {
    //         if (mode === "edit" && defaultValues && contentOptions.length > 0) {
    //              reset({
    //             ...defaultValues,
    //             contentManag:
    //                 contentOptions.find(
    //                 (opt) => opt.value === String(defaultValues?.contentManag?.value)
    //                 ) || null,
    //             });
    //         }
    // }, [mode, defaultValues, contentOptions, reset]);
    // useEffect(() => {
    //     if (mode === "edit" && defaultValues && contentOptions.length) {
    //         reset({
    //         ...defaultValues,
    //         contentManag: getMatchedContent(defaultValues.contentManag?.value),
    //         });
    //     }
    //    }, [mode, defaultValues, contentOptions, reset]);

    // useEffect(() => {
    //     if (
    //         mode === "edit" &&
    //         defaultValues &&
    //         contentOptions.length &&
    //         adList.length
    //     ) {
    //         reset({
    //             ...defaultValues,
    //             // Content Management
    //             // contentManag: getMatchedContent(defaultValues.contentManag?.value),
    //             contentManag: getMatchedContent(defaultValues.contentId),

    //             // Ad Settings
    //             ads: defaultValues.ads?.map(ad => ({
    //                 ...ad,
    //                 selectAd: getMatchedAd(ad.selectAd?.value),
    //             })),
    //         });
    //     }
    // }, [mode, defaultValues, contentOptions, adList, reset]);

    //         useEffect(() => {
    //   if (
    //     mode === "edit" &&
    //     defaultValues &&
    //     contentOptions.length &&
    //     adList.length && 
    //     Array.isArray(defaultValues.settingOptions)
    //   ) {
    //     // Reset NON-array fields only
    //     reset({
    //       ...defaultValues,
    //       contentManag: getMatchedContent(defaultValues.contentId),
    //     });

    //     // Replace field array properly
    //     replace(
    //       defaultValues.settingOptions.map(ad => ({
    //         backendId: ad.id,                 // ✅ rename (do NOT use "id")
    //         instreamSetupId: ad.instreamSetupId,
    //         adType: ad.adType,
    //         adTime: ad.adTime || "",
    //         selectAd: getMatchedAd(ad.adId),
    //       }))
    //     );
    //   }
    // }, [mode, defaultValues, contentOptions, adList, reset, replace]);

    useEffect(() => {
        if (
            mode === "edit" &&
            defaultValues &&
            contentOptions.length &&
            // adList.length &&
            Array.isArray(defaultValues.settingOptions)
        ) {
            // ✅ reset ONLY non-array fields
            reset({
                ...defaultValues,
                contentManag: getMatchedContent(defaultValues.contentManag?.value),
                //   contentManag: getMatchedContent(defaultValues.contentId),
            });

            // ✅ handle ads separately
            replace(
                defaultValues.settingOptions.map(ad => ({
                    backendId: ad.id,                 // backend row id
                    instreamSetupId: ad.instreamSetupId,
                    adType: ad.adType,
                    adTime: ad.adTime || "",
                    selectAd: getMatchedAd(ad.adId),
                }))
            );
        }
    }, [mode, defaultValues, contentOptions, adList, reset, replace]);



    useEffect(() => {
        Promise.all([contentApi(), AdData()]);
    }, []);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                {/* <span>{publisherName}</span> */}
                <Link to={`/publisher/info/${accId}/${accGuid}`}><span>{publisherName}</span></Link>
                <Link to={`/publisher/instream-setting-list/${accId}/${accGuid}`}><span>Manage Instream Setting</span></Link>
                <span>{mode === "edit" ? "Update" : "Create"}</span>
                {/* {mode === "edit" ? <span>{accId}</span> : ''} */}
            </div>
            <Card className="p-3 instreamRows">
                <span className="text-danger" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <h6 className="title mb-5">Instream Setting</h6>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* Label */}
                    <Row>
                        <Col md={3}>
                            <label>
                                Label <span className="text-danger">*</span>
                            </label>
                        </Col>
                        <Col md={5}>
                            <Form.Control type="text" placeholder="Enter label here..." 
                            // {...register("label", { required: "Label is required" })} 
                                {...register("label", {
                                    setValueAs: (value) =>
                                        typeof value === "string" ? value.trim() : value,
                                    required: "Label is required"
                                })} 
                            />
                            {errors.label && <p className="text-danger">{errors.label.message}</p>}

                        </Col>
                    </Row>
                    {/* Content Management */}
                    <Row>
                        <Col md={3}>
                            <label>
                                Content Management <span className="text-danger">*</span>
                            </label>
                        </Col>
                        <Col md={5}>
                            <Controller
                                name="contentManag"
                                control={control}
                                rules={{ required: "Content Management is required" }}   // REQUIRED
                                render={({ field, fieldState }) => (
                                    <>
                                        <Select
                                            className="fieldFont"
                                            {...field}
                                            options={contentOptions}
                                            isSearchable
                                            placeholder="Search here..."
                                        />

                                        {fieldState.error && (
                                            <small style={{ color: "red", fontSize: "11px" }}>
                                                {fieldState.error.message}
                                            </small>
                                        )}
                                    </>
                                )}
                            />
                            <small style={{ fontSize: "10px", color: "#333333" }}>
                                search through title
                            </small>
                        </Col>

                    </Row>
                    {/* Mobile Player Size */}
                    <Row>
                        <Col md={3}>
                            <label>
                                Mobile player size <span className="text-danger">*</span>
                            </label>
                        </Col>
                        <Col md={5}>
                            <Controller
                                name="mobileSize"
                                control={control}
                                rules={{ required: "Mobile player size is required" }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <Select
                                            className="fieldFont"
                                            {...field}
                                            options={mobilePlayerSizes}
                                            isSearchable
                                            placeholder="Search here..."
                                        />

                                        {fieldState.error && (
                                            <small style={{ color: "red", fontSize: "11px" }}>
                                                {fieldState.error.message}
                                            </small>
                                        )}
                                    </>
                                )}
                            />
                            <small style={{ fontSize: "10px", color: "#333333" }}>
                                search through title
                            </small>
                        </Col>

                    </Row>
                    {/* Custom Mobile Width + Height Fields (Shown only if custom is selected) */}
                    {selectedMobileSize?.value === "custom" && (
                        <>
                            <Row>
                                <Col md={3}>
                                    <label>
                                        Custom Width <span className="text-danger">*</span>
                                    </label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" min={0} placeholder="Width" {...register("custom_mob_width", { required: "Custom width is required" })} />
                                    {errors.custom_mob_width && <p className="text-danger">{errors.custom_mob_width.message}</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <label>
                                        Custom Height <span className="text-danger">*</span>
                                    </label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" min={0} placeholder="Height" {...register("custom_mob_height", { required: "Custom height is required" })} />
                                    {errors.custom_mob_height && <p className="text-danger">{errors.custom_mob_height.message}</p>}
                                </Col>
                            </Row>
                        </>
                    )}
                    {/* Desktop Player Size */}
                    <Row>
                        <Col md={3}>
                            <label>
                                Desktop player size <span className="text-danger">*</span>
                            </label>
                        </Col>
                        <Col md={5}>
                            <Controller
                                name="desktopSize"
                                control={control}
                                rules={{ required: "Desktop player size is required" }}   // REQUIRED
                                render={({ field, fieldState }) => (
                                    <>
                                        <Select
                                            className="fieldFont"
                                            {...field}
                                            options={desktopPlayerSizes}
                                            isSearchable={false}
                                            placeholder="Search here..."
                                        />

                                        {fieldState.error && (
                                            <small style={{ color: "red", fontSize: "11px" }}>
                                                {fieldState.error.message}
                                            </small>
                                        )}
                                    </>
                                )}
                            />
                            <small style={{ fontSize: "10px", color: "#333333" }}>
                                search through title
                            </small>
                        </Col>

                    </Row>
                    {/* Custom Desktop Width + Height Fields (Shown only if custom is selected) */}
                    {selectedDesktopSizes?.value === "custom" && (
                        <>
                            <Row>
                                <Col md={3}>
                                    <label>Custom Width<span className="text-danger">*</span></label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" placeholder="Width" {...register("custom_desk_width", { required: "Custom width is required" })} />
                                    {errors.custom_desk_width && <p className="text-danger">{errors.custom_desk_width.message}</p>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={3}>
                                    <label>Custom Height<span className="text-danger">*</span></label>
                                </Col>
                                <Col md={5}>
                                    <Form.Control type="number" min={0} placeholder="Height" {...register("custom_Desk_Height", { required: "Custom height is required" })} />
                                    {errors.custom_Desk_Height && <p className="text-danger">{errors.custom_Desk_Height.message}</p>}
                                </Col>
                            </Row>
                        </>
                    )}
                    {/* Header Bidding */}
                    <Row>
                        <Col md={3}>
                            <label>Header Bidding</label>
                        </Col>
                        <Col md={5}>
                            <Form.Select {...register("header_biding")}>
                                <option value="">No</option>
                                <option value="1">Yes</option>
                            </Form.Select>
                            <small>In case of Yes, Header bidding will be enabled.</small>
                        </Col>
                    </ Row>

                    {/* Enable Ad Request Before Video content Start */}
                    <Row>
                        <Col md={3}>
                            <label>Enable Ad Request Before Video content Start</label>
                        </Col>
                        <Col md={5}>
                            {/* <Form.Select {...register( "init_ad_req", { valueAsNumber: true })}> */}
                            <Form.Select {...register("init_ad_req")}>
                                <option value="">No</option>
                                <option value="1">Yes</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    {initialAdRequest == 1 ? (
                        <>
                            {/* Enable Ad Request Before Video content Start  */}
                            <Row>
                                <Col md={3}>
                                    <label>Initial Ad Request Calls only on viewport</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Select {...register("view_port_init_req", {
                                    })}>
                                        <option value="">No</option>
                                        <option value="1">Yes</option>
                                    </Form.Select>
                                    <small>In case of Yes, ad calls will fire only on viewport before playing video content.</small>
                                </Col>
                            </Row>
                        </>
                    ) : (
                        <>
                            {/* Video content Auto play */}
                            <Row>
                                <Col md={3}>
                                    <label>Video content Auto play</label>
                                </Col>
                                <Col md={5}>
                                    <Form.Select name="autoPlay" {...register("autoPlay")}>
                                        <option value="">No</option>
                                        <option value="1">On Page Load</option>
                                        <option value="2">Initial On Viewport</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                        </>
                    )
                    }
                    {/* When out of View  */}
                    <Row>
                        <Col md={3}>
                            <label>When out of View</label>
                        </Col>
                        <Col md={5}>
                            <Form.Select {...register("out_of_view")}>
                                <option value="0">Pause</option>
                                <option value="2">Keep_Playing</option>
                            </Form.Select>
                            <small>Note: Initially, pause setting will be ignored in case of Initial Ad Request Calls set as Yes.</small>
                        </Col>
                    </Row>
                    {/* In view */}
                    <Row>
                        <Col md={3}>
                            <label>In view <span className="text-danger">*</span> </label>
                        </Col>
                        <Col md={5}>
                            <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("in_view", { required: "In view is required" })} />
                            {errors.in_view && <p className="text-danger">{errors.in_view.message}</p>}
                        </Col>
                    </Row>
                    {/* Video Controls*/}
                    <Row>
                        <Col md={3}>
                            <label>Video Controls</label>
                        </Col>
                        <Col md={5}>
                            <Form.Select {...register("video_controls")}>
                                <option value="">No</option>
                                <option value="1">Yes</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    {seekbarEnable == 1 && (
                        // { Seekbar Enable }
                        <Row>
                            <Col md={3}>
                                <label>Seekbar Enable</label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("video_controls_enable")}>
                                    <option value="">No</option>
                                    <option value="1">Yes</option>
                                </Form.Select>
                            </Col>
                        </Row>
                    )}
                    {/* Video Controls Over Ad*/}
                    <Row>
                        <Col md={3}>
                            <label>Video Controls Over Ad</label>
                        </Col>
                        <Col md={5}>
                            <Form.Select {...register("ad_controls")}>
                                <option value="">No</option>
                                <option value="1">Yes</option>
                            </Form.Select>
                        </Col>
                    </Row>
                    {/* Powered By Click Url */}
                    <Row>
                        <Col md={3}>
                            <label>Powered By Click Url</label>
                        </Col>
                        <Col md={5}>
                            <input type="text" className="form-control" placeholder="Enter here..." {...register("powered_by_link")} />
                        </Col>
                    </Row>
                    {/* Powered By Text */}
                    <Row>
                        <Col md={3}>
                            <label>Powered By</label>
                        </Col>
                        <Col md={5}>
                            <input type="text" className="form-control" placeholder="Enter here..." {...register("powered_by_text")} />
                        </Col>
                    </Row>
                    {/* Powered By Image URL */}
                    <Row>
                        <Col md={3}>
                            <label>Powered By Image URL</label>
                        </Col>
                        <Col md={5}>
                            <input type="text" className="form-control" placeholder="Enter here..." {...register("powered_by_img")} />
                        </Col>
                    </Row>
                    <Card className="p-3 instreamRows">
                        <h6 className="subTitle">Instream Ad Setting</h6>
                        {/* Is Detachable */}
                        <Row>
                            <Col md={3}>
                                <label>Is Detachable</label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("is_detachable")}>
                                    <option value="">No</option>
                                    <option value="1">Yes</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        {IsDetachableYes == 1 && (
                            <>
                                {/* Pixel From Bottom */}
                                <Row>
                                    <Col md={3}>
                                        <label>Pixel From Bottom</label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("bottom_px")} />
                                        <small>To handle pixel from bottom (Allow only numeric value)</small>
                                    </Col>
                                </Row>
                                {/* InitialDetach When User is out of view */}
                                <Row>
                                    <Col md={3}>
                                        <label>InitialDetach When User is out of view</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Select {...register("viewport_init_req_detach")}>
                                            <option value="">No</option>
                                            <option value="1">Yes</option>
                                        </Form.Select>
                                        <small>Note: It will be ignored in case of Initial Ad Request Calls only on viewport set as Yes OR Video content Auto play set as Initial On Viewport.</small>
                                    </Col>
                                </Row>
                                {/* Detachable Close Action */}
                                <Row>
                                    <Col md={3}>
                                        <label>Detachable Close Action</label>
                                    </Col>
                                    <Col md={5}>
                                        <Form.Select {...register("detach_close_action")}>
                                            <option value="1">Default - After Close Disappear</option>
                                            <option value="0">After close, Detach everytime</option>
                                            <option value="2">Detach When Ads rendered</option>
                                        </Form.Select>
                                    </Col>
                                </Row>
                                {/* Detach Mobile Size Width */}
                                <Row className="mb-4">
                                    <p style={{ fontSize: "15px" }}>Detach Mobile Size <span className="text-danger">*</span></p>
                                    <Col md={3}>
                                        <label>Width<span className="text-danger">*</span></label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("detach_mobile_width", { required: "Width is required" })} />
                                        {errors.detach_mobile_width && <p className="text-danger">{errors.detach_mobile_width.message}</p>}
                                    </Col>
                                </Row>
                                {/* Detach Mobile Size Height */}
                                <Row>
                                    <Col md={3}>
                                        <label>Height<span className="text-danger">*</span></label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("detach_mobile_height", { required: "Height is required" })} />
                                        {errors.detach_mobile_height && <p className="text-danger">{errors.detach_mobile_height.message}</p>}
                                    </Col>
                                </Row>
                                {/* Detach Desktop Size Width */}
                                <Row className="mb-4">
                                    <p style={{ fontSize: "15px" }}>Detach Desktop Size <span className="text-danger">*</span></p>
                                    <Col md={3}>
                                        <label>Width<span className="text-danger">*</span></label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("detach_desktop_width", { required: "Width is required" })} />
                                        {errors.detach_desktop_width && <p className="text-danger">{errors.detach_desktop_width.message}</p>}
                                    </Col>
                                </Row>
                                {/* Detach Desktop Size Height */}
                                <Row>
                                    <Col md={3}>
                                        <label>Height<span className="text-danger">*</span></label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("detach_desktop_height", { required: "Height is required" })} />
                                        {errors.detach_desktop_height && <p className="text-danger">{errors.detach_desktop_height.message}</p>}
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Card>
                    <Card className="p-3 instreamRows mt-5">
                        <h6 className="subTitle">GAM Settings</h6>
                        {/* Wrapper Style */}
                        <Row>
                            <Col md={3}>
                                <label>Wrapper Style</label>
                            </Col>
                            <Col md={5}>
                                <textarea as="text" className="form-control" rows={5} placeholder="Enter here..." {...register("wrapper_style")} />
                            </Col>
                        </Row>
                        {/* Retry Ad */}
                        <Row>
                            <Col md={3}>
                                <label>Retry Ad</label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("is_retry", {
                                    validate: (value) => {
                                        if (initialAdRequest === "1" && value !== "1") {
                                            return "Retry setting must be set as Yes in case of initial ad request calls."
                                        }
                                        return true;
                                    }
                                },
                                )}
                                >
                                    <option value="">No</option>
                                    <option value="1">Yes</option>
                                </Form.Select>
                                {errors.is_retry && <p className="text-danger">{errors.is_retry.message}</p>}

                            </Col>
                        </Row>
                        {RetryAdYes == 1 && (
                            <>
                                {/* Retry Interval */}
                                <Row>
                                    <Col md={3}>
                                        <label>Retry Interval (In Milliseconds) <span className="text-danger">*</span></label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("retry_interval", { required: "Retry interval is required" })} />
                                        {errors.retry_interval && <p className="text-danger">{errors.retry_interval.message}</p>}
                                    </Col>
                                </Row>
                                {/* Max Retry Count */}
                                <Row>
                                    <Col md={3}>
                                        <label>Max Retry Count <span className="text-danger">*</span></label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("max_retry_count", { required: "Max Retry Count is required" })} />
                                        {errors.max_retry_count && <p className="text-danger">{errors.max_retry_count.message}</p>}
                                    </Col>
                                </Row>
                                {/* Max Ad Display Count */}
                                <Row>
                                    <Col md={3}>
                                        <label>Max Ad Display Count <span className="text-danger">*</span></label>
                                    </Col>
                                    <Col md={5}>
                                        <input type="number" min={0} className="form-control" placeholder="Enter here..." {...register("max_ad_display_count", { required: "Max Ad Display Count is required" })} />
                                        {errors.max_ad_display_count && <p className="text-danger">{errors.max_ad_display_count.message}</p>}
                                    </Col>
                                </Row>
                            </>
                        )}

                        {/* Is Content Replay */}
                        <Row className="mb-4">
                            <Col md={3}>
                                <label>Is Content Replay</label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("is_content_replay")}>
                                    <option value="">No</option>
                                    <option value="1">Yes</option>
                                </Form.Select>
                            </Col>
                        </Row>

                        {IsContentReplay == 1 && (
                            // {/* Content Replay Count */} 
                            <Row>
                                <Col md={3}>
                                    <label>Content Replay Count<span className="text-danger">*</span></label>
                                </Col>
                                <Col md={5}>
                                    <input type="number" className="form-control" placeholder="Enter here..." {...register("content_replay_count", { required: "Content Replay Count is required" })} />
                                    {errors.content_replay_count && <p className="text-danger">{errors.content_replay_count.message}</p>}
                                </Col>
                            </Row>
                        )}
                        {/* Is Companion Ad */}
                        <Row className="mb-4">
                            <Col md={3}>
                                <label>Is Companion Ad <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("is_companion_ad")}>
                                    <option value="">No</option>
                                    <option value="1">Yes</option>
                                </Form.Select>
                            </Col>
                        </Row>
                        {IsCompanionAdYes == 1 && (
                            // {/* Is Companion Ad */} 
                            <Row className="mb-4">
                                <Col md={3}>
                                    <label>Is Companion Ad Unit <span className="text-danger">*</span> </label>
                                </Col>
                                <Col md={5}>
                                    <input type="text" className="form-control" placeholder="Enter here..." 
                                    // {...register("is_companion_ad_unit", { required: "Is Companion Ad Unit required" })} 
                                    {...register("is_companion_ad_unit", {
                                        setValueAs: (value) =>
                                            typeof value === "string" ? value.trim() : value,
                                        required: "Is Companion Ad Unit required"
                                    })} 
                                    />
                                    {errors.is_companion_ad_unit && <p className="text-danger">{errors.is_companion_ad_unit.message}</p>}
                                    
                                </Col>
                            </Row>
                        )}
                        {/* Mapped as GAM creative */}
                        <Row>
                            <Col md={3}>
                                <label>Mapped as GAM creative<span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Select {...register("via_Gam")}>
                                    <option value="">No</option>
                                    <option value="1">Yes</option>
                                </Form.Select>
                            </Col>
                        </Row>
                    </Card>
                    <Card className="p-3 instreamRows mt-5 card">
                        <h6 className="subTitle">AD Settings</h6>
                        <span className="" style={{ fontSize: "12px", margin: "5px 0 10px 0" }}>Note: In case of retry = yes, Adtype & Ad Time values will be ignored.</span>
                        {
                            fields.map((items, index) => {
                                const selectedAdType = watch(`ads.${index}.adType`);
                                return (
                                    <div key={items.id} className="mb-4 p-3 border rounded">
                                        {/* Row 1: Select Ad */}
                                        <span className="adSettingsIdx">#AD Setting {index + 1}</span>
                                        <Row className="mb-3">
                                            <Col md={3}>
                                                <label>Select Ad</label>
                                            </Col>
                                            <Col md={5}>
                                                {/* Select Ad */}
                                                <Controller name={`ads.${index}.selectAd`} control={control} render={({ field }) => (
                                                    <Select className="fieldFont" {...field} options={adList} placeholder="Select Ad" />
                                                )} />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md={3}>
                                                <label>Ad Type *</label>
                                            </Col>
                                            <Col md={5}>
                                                {/* Ad Type */}
                                                <Form.Select {...register(`ads.${index}.adType`)}>
                                                    <option value="PRE">Pre-Roll</option>
                                                    <option value="MID">Mid-Roll</option>
                                                    <option value="POST">Post-Roll</option>
                                                    <option value="CUSTOM">Custom</option>
                                                </Form.Select>
                                            </Col>
                                        </Row>
                                        {/* Custom time */}
                                        {selectedAdType === "CUSTOM" && (
                                            <Row className="mb-3">
                                                <Col md={3}>
                                                    <label>Time (in seconds)</label>
                                                </Col>
                                                <Col md={5}>
                                                    <input type="number" min={0} className="form-control" placeholder="Time in seconds" {...register(`ads.${index}.adTime`)} />
                                                </Col>
                                            </Row>
                                        )}
                                        {/* Delete */}
                                        {index > 0 && (
                                            <>
                                                <Button type="button" variant="danger" onClick={() => remove(index)}>Delete</Button>
                                                {/* <Button type="button"  variant="success"  onClick={() => append({ selectAd: null,adType: "PRE",
                                adTime: ""})} style={{width:"90px",height:"40px"}}><span style={{fontSize:"30px",height:"30px",lineHeight:"30px"}}>+</span></Button> */}
                                            </>
                                        )}
                                    </div>
                                )
                            })}
                        <Button type="button" variant="success" onClick={() => append({
                            selectAd: null, adType: "PRE",
                            adTime: ""
                        })} style={{ width: "90px", height: "40px" }}><span style={{ fontSize: "30px", height: "30px", lineHeight: "24px" }}>+</span></Button>

                    </Card>
                    <Button type="submit" variant="primary" disabled = {btnClicked} className="mt-3 submitBtn">{mode === "add" ? "Create" : "Update"}</Button>
                    <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={() => navigate(`/publisher/instream-setting-list/${accId}/${accGuid}`)}>Cancel</Button>
                </form>
            </Card>
        </FormLoader>
    )
}

export default InstreamAdSetting;